import {useEffect} from "react";
import {useActiveVkuiLocation, useGetPanelForView, useRouteNavigator} from "@vkontakte/vk-mini-apps-router";
import {DEFAULT_VIEW, GAME_PANEL, HOME_PANEL} from "../routing/routing";
import {
    hideTelegramBackButton,
    isTelegramWebAppAvailable,
    setTelegramBackButtonHandler,
    showTelegramBackButton
} from "../services/telegramWebApp";

export const useAppNavigation = () => {
    const routeNavigator = useRouteNavigator();
    const {view: activeView, modal: activeModal} = useActiveVkuiLocation();
    const activePanel = useGetPanelForView(DEFAULT_VIEW);
    const shouldShowBackButton = Boolean(activeModal) || activePanel !== HOME_PANEL;

    useEffect(() => {
        if (!isTelegramWebAppAvailable()) {
            return undefined;
        }

        if (!shouldShowBackButton) {
            hideTelegramBackButton();
            return undefined;
        }

        showTelegramBackButton();

        const unsubscribe = setTelegramBackButtonHandler(() => {
            if (activeModal) {
                routeNavigator.hideModal();
                return;
            }

            // Для игровой панели всегда инициируем явный уход на главную,
            // чтобы сработал blocker и показал модалку подтверждения выхода.
            if (activePanel === GAME_PANEL) {
                routeNavigator.replace("/");
                return;
            }

            routeNavigator.back();
        });

        return () => {
            unsubscribe();
            hideTelegramBackButton();
        };
    }, [activeModal, routeNavigator, shouldShowBackButton]);

    return {
        routeNavigator,
        activeView,
        activeModal,
        activePanel,
    };
};
